import { useCallback } from "react";
import { useLazyGetPersonsQuery } from "@api/personasApi";

const EMPTY_ID = "00000000-0000-0000-0000-000000000000";

/**
 * Persona que el registro ya dio de alta en la solicitud (titular PFAE / PF), para actualizarla en vez de crear otra.
 * Si el usuario sale de la pantalla, inicia sesión y vuelve a continuar, un segundo alta truena porque el correo o el
 * RFC ya están registrados. En el registro la solicitud tiene una sola persona: se toma la primera. Regresa `""` si
 * todavía no existe.
 */
export const useExistingPersonId = () => {
  const [getPersons] = useLazyGetPersonsQuery();

  return useCallback(
    async (loanApplicationId: string): Promise<string> => {
      if (!loanApplicationId || loanApplicationId === EMPTY_ID) return "";

      const [person] = await getPersons({ loanApplicationId }).unwrap();
      return person?.id ? String(person.id) : "";
    },
    [getPersons],
  );
};
